import { useState, useEffect } from "react";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { DialogTitle } from "../shared/modal";
import { useInviteFriendModalStore } from "../../../js/stores/invite-friend-modal-store";
import {
  useInviteFriendForm,
  useInviteEmail
} from "../../../js/api/invite-friend/invite-friend-form";
import { InviteFriendForm } from "./invite-friend-form";
import { useInviteFriendStore } from "~/js/stores/invite-friend-store";
import { SharedIcon } from "~/react/components/shared/shared-icon";

export function InviteFriendContent({ closeClickHandler }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const inviteFriendUrl = useInviteFriendModalStore(
    (state) => state.inviteFriendUrl
  );
  const recaptchaSiteKey = useInviteFriendStore((state) => state.recaptchaSiteKey);
  const { data, isLoading, isError } = useInviteFriendForm({
    inviteFriendUrl,
  });
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const sendEmailAction = useInviteEmail();
  const [message, setMessage] = useState("");

  const submitFormHandler = async (body) => {
    if (data?.mainAction?.linkUrl && body && !!recaptchaSiteKey) {
      setIsSubmitting(true);
      try {
        const token = await grecaptcha.execute(recaptchaSiteKey, {
          action: "submit",
        });

        sendEmailAction.mutate({
          url: data?.mainAction?.linkUrl,
          body: {
            "email": body?.Email,
            "formToken": token
          },
          successHandler: (response) => {
            setIsSubmitting(false);
            setIsSent(true);
            setMessage(response?.message);
          },
          errorHandler: (data) => {
            setIsSubmitting(false);
            if (data?.response?.data?.errors) {
              setServerErrors({ ...data?.response?.data?.errors });
            }
          },
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (!recaptchaSiteKey) return;

    const scriptId = "recaptcha-script";
    if (window.grecaptcha || document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, [recaptchaSiteKey]);

  if (isLoading || isSubmitting) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <div className="invite-friend-form-wrapper">
      <div className="invite-friend-form-content">
        <div className="invite-friend-form-header">
          <div className="invite-friend-form-container">
            <DialogTitle className="invite-friend-form-title">
              {data?.modalLabel}
            </DialogTitle>
          </div>
        </div>
        <div className="invite-friend-form-main">
          <div className="invite-friend-form-container">
            {!isSent && data?.fields?.length > 0 && (
              <InviteFriendForm
                submitHandler={submitFormHandler}
                data={data}
                isFormSubmitting={isFormSubmitting}
                setIsFormSubmitting={setIsFormSubmitting}
                serverErrors={serverErrors}
                setServerErrors={setServerErrors}
              />
            )}
            {isSent && (
              <>
                <SharedIcon iconName={"#icon-success-tick"} className="invite-friend-form-success-icon"/>
                <div className="invite-friend-form-success-message">
                  {message?.length > 0 ? message : "Your invitation has been sent."}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="invite-friend-form-footer">
          <div className="invite-friend-form-container">
            <div className="invite-friend-form-actions-wrapper">
              {!isSent && data?.mainAction && (
                <button
                  className="button grey invite-friend-form-button"
                  type="button"
                  onClick={() => setIsFormSubmitting(true)}
                >
                  {data?.mainAction?.linkLabel}
                </button>
              )}
              {isSent && (
                <button
                  className="button grey"
                  type="button"
                  onClick={closeClickHandler}
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
